import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Layers = function Layers(props) {
  useDeprecatedComponentWarning({
    component: 'Layers'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M1562 1189l151-97 317 184-1001 639L28 1276l316-184 152 97-161 93 694 443 693-443zm-533 188L28 738l1001-580 1001 580zM335 745l694 443 693-443-693-402z"
  }));
};

Layers.displayName = 'Layers';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Layers.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Layers;